
import Vue from "vue";
import Mfa from "./Mfa.vue";
import {TOTP_REGEX} from "../../../constant/regex";
import errorService from "../../../services/errorService";
import msDataProvider from "../../../services/msDataProvider";
import {EnterOtpStep, OTP_METHOD, OtpType} from "@/constant/login";
import loginService from "@/services/loginService";

export default Vue.extend({
  components: {
    Mfa,
  },
  props: ["icon"],
  data() {
    return {
      OtpType,
      alertOptions: {
        title: this.$t('ERROR_SERVICE.ERROR_DETAIL'),
        no: this.$t('APP.CLOSE')
      },
      errorService,
      isShowQrCode: true,
      otp: "",
      errorPrepare: "",
      showMenu: false,
      binding: {},
      showDetailError: false,
      alertShown: false,
      otpTypeItems: [] as any,
      otpTypeLabels: {
        [OtpType.EmailOtp]: 'Email OTP',
        [OtpType.SMS]: 'SMS OTP',
        [OtpType.RADIUS]: 'Radius OTP',
        [OtpType.TOTP]: 'TOTP',
        [OtpType.SecurityKey]: 'Security Key'
      },
      step: EnterOtpStep.ENTER_OTP,
      enterOtpStepEnum: EnterOtpStep,
      prepareResponse: loginService.getPrepareLoginResponse(),
      prepareLoading: false,
      resendLoading: {
        [OtpType.SMS]: 0,
        [OtpType.EmailOtp]: 0,
      },
      expected_mfas: [],
      totpQRCodeExpiredDialogOptions: {
        title: this.$t("LAYOUT.QRCODE_EXPIRED"),
        ok: this.$t("LAYOUT.CONFIRM"),
        closeable: false
      },
      totpQRCodeExpired: false,
      error: ""
    };
  },
  watch: {
    otp(value: string) {
      if (value && isNaN(Number(value))) {
        this.otp = null ;
        return;
      }
    },
    isShowQrCode: {
      handler(value) {
        this.$router.push({query: { isShowQrCode: value }});
        if(value === true) {
          this.error = ""
        }
      },
      immediate: true
    },
    '$route.query': {
      handler(value) {
        if (typeof value.isShowQrCode !== 'undefined') {
          this.isShowQrCode = value.isShowQrCode === 'true' || value.isShowQrCode === true;
        }
      }
    }
  },
  methods: {
    alertClose() {
      this.alertShown = false;
    },
    nextStep() {
      this.isShowQrCode = false;
    },
    showDetail() {
      this.alertShown = true;
    },
    parseData(dataStr) {
      try {
        return JSON.parse(dataStr);
      } catch (e) {
        return dataStr
      }
    },
    errorChange(error) {
      this.otp = "";
      this.error = error;
    },
    async prepare(params: any = {}) {
      this.errorPrepare = "";
      try {
        this.prepareLoading = true;
        const response = await msDataProvider.executeCommand(
            "authenPrepareLogin",
            params
        );

        if (response.error_info.error_code) {
          this.errorPrepare = response.error_info.message;
        }
        loginService.setPrepareLoginResponse(response);
        this.prepareResponse = response;
        if (!response.type) {
          this.$router.push("/prepare").catch((e) => e);
          return;
        }
      } catch (e) {
        this.errorPrepare = e;
      } finally {
        this.prepareLoading = false;
        if(this.prepareResponse.type === "Totp") {
          this.isQRCodeValid(this.prepareResponse)
        }
      }
    },
    async handleKeyDownEventOtp(e: KeyboardEvent, resetError) {
      resetError();
      this.errorPrepare = "";
      if (isNaN(Number(e.key)) &&
          !e.key.includes('Delete') &&
          !e.key.includes('Arrow') &&
          !e.key.includes('Backspace') &&
          !(e.key.toLowerCase() === 'c' && e.ctrlKey) &&
          !(e.key.toLowerCase() === 'v' && e.ctrlKey) &&
          !(e.key.toLowerCase() === 'a' && e.ctrlKey)
      ) {
        // only 0-9, backspace, delete button, left arrow, right arrow, ctrl + a-c-v
        e.preventDefault();
      }
    },
    handleKeyUpEventOtp(callback) {
      if (TOTP_REGEX.test(this.otp)) {
        if (this.otp.length === 6) {
          callback({ otp: this.otp });
        }
      }
    },
    async handlePaste(e) {
      const text = await e.clipboardData.getData('text');
      if (isNaN(+text)) {
        e.preventDefault();
        return;
      }
    },
    async resendOtp(resetError: any) {
      if (this.resendLoading[this.prepareResponse.type] > 0) {
        return;
      }
      if (typeof resetError === 'function') {
        resetError()
      }
      this.resendLoading[this.prepareResponse.type] = 30;
      await this.prepare({ force_new_session: true, expected_mfas: [this.prepareResponse.type] });
      const prepareLoginType = this.prepareResponse.type;
      const countResend = setInterval(() => {
        --this.resendLoading[prepareLoginType];
        if (this.resendLoading[prepareLoginType] <= 0) {
          clearInterval(countResend);
        }
      }, 1000);
    },
    async changeOtpType(type: OtpType) {
      this.expected_mfas = [type];
      this.$router.push({ path: '/login/prepare', query: { type } });
    },
    submit(event, onReadyToSubmit) {
      if (event.target.value.length === 6 && TOTP_REGEX.test(this.otp)) {
        onReadyToSubmit({ otp: this.otp });
        return;
      }
    },
    isQRCodeValid(prepareResponse: any) {
      if(this.parseData(prepareResponse.data).duration) {
        let countDown = this.parseData(this.prepareResponse.data).duration
        const timer = setInterval(() => {
          countDown--;
          if(countDown === 0) {
            clearInterval(timer);
            this.totpQRCodeExpired = true;
          }
        }, 1000)
      }
    },
    async refreshTOTP() {
      this.totpQRCodeExpired = false;
      this.isShowQrCode = true;
      this.error = "";
      await this.prepare({ force_new_session: true, expected_mfas: [this.prepareResponse.type] })
    }
  },
  created() {
    if (Array.isArray(this.prepareResponse.available_mfas)) {
      this.prepareResponse.available_mfas.map(mfa => {
        if (OTP_METHOD.includes(mfa)) {
          this.otpTypeItems.push(mfa);
        }
      })
    }
    this.isQRCodeValid(this.prepareResponse)
  },
  mounted() {
    if (this.$refs.otpInput) {
      this.$refs.otpInput.focus?.();
    }
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
